import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { ProductTypesComponent } from './product-types.component';
import { AuthGuard } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ItemArrowComponent } from '../../core/components/item-arrow/item-arrow.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FiltersModule } from 'src/app/filters/filters.module';
import { ArrowButtonComponent } from '../../core/components/arrow-button/arrow-button.component';
import { ProductTypeItemComponent } from './components/product-type-item.component';
import { ColumnToggleComponent } from './components/column-toggle.component';
import { EstimateComponent } from './components/estimate.component';
import { EstimateSliderComponent } from './components/estimate-slider.component';
import { ColorSpectrumService } from './services/color-spectrum.service';
import { CommissionEstimateService } from './services/commission-estimate.service';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'product-types/:categoryId',
        component: ProductTypesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'product-types/:categoryId/:productTypeId',
        component: ProductTypesComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'product-types/search/:categoryId/:productTypeId',
        component: ProductTypesComponent,
        canActivate: [AuthGuard],
      },
    ]),
    InfiniteScrollModule,
    CommonModule,
    CoreModule,
    MatTooltipModule,
    ItemArrowComponent,
    FiltersModule,
    ArrowButtonComponent,
    ColumnToggleComponent,
    EstimateComponent,
    EstimateSliderComponent,
  ],
  providers: [ColorSpectrumService, CommissionEstimateService],
  declarations: [ProductTypesComponent, ProductTypeItemComponent],
})
export class ProductTypesModule {}
